import axios from "axios";
import ReactGA from "react-ga";
import _ from "lodash";
import { history } from "./store";

/**
 * -areEqualShallow-
 * @param {object}
 * @param {object}
 * @returns {bool}
 * Checks for object equality
 **/
export function areEqualShallow(a, b) {
	for (var key_a in a) {
		if (!(key_a in b) || a[key_a] !== b[key_a]) {
			return false;
		}
	}
	for (var key_b in b) {
		if (!(key_b in a) || a[key_b] !== b[key_b]) {
			return false;
		}
	}
	return true;
}

/**
 * -delay-
 * @param {int} time
 * @returns {promise}
 **/
export function wait(t) {
	return new Promise((resolve, reject) => {
		setTimeout(resolve, t);
	});
}

/**
 * -capitalise-
 * @param {string}
 * @returns {string}
 * Capitalises whatever you give it
 **/
export function capitalise(string) {
	return _.startCase(_.toLower(string));
}

/**
 * -capitalise-
 * @param {int} metres
 * @returns {string}
 * Format Distance - if less than 500m then shom metres, else show as km
 **/
export function metricDistance(metres) {
	return metres < 500
		? metres + "m"
		: parseFloat(Math.round((metres / 1000) * 100) / 100).toFixed(2) + "km";
}

/**
 * -colorFromMode-
 * @param {string} mode
 * @returns {string}
 * Returns color depending on mode, string passed or random
 **/
export function colorFromMode(mode) {
	let color;

	switch (mode) {
		case "walk":
		case "foot":
			color = "#84B9E8";
			break;
		case "bus":
			color = "#3F87C9";
			break;
		case "train":
		case "rail":
			color = "#74368F";
			break;
		case "cycle":
		case "bike":
			color = "#009F8A";
			break;
		case "drive":
		case "car":
			color = "#A31784";
			break;
		case "random":
			color =
				"#" +
				("000000" + Math.random().toString(16).slice(2, 8).toUpperCase()).slice(
					-6
				);
			break;
		default:
			color = mode;
	}

	return color;
}

/**
 * -getLocationByID-
 * @param {int} id
 * @returns {object} posts
 * Gets posts from WP-API for a given post type
 **/
export function getLocationByID(id) {
	return new Promise((resolve, reject) => {
		// localhost
		var query_url = `${ window.QUERY_ROOT }/fetch/location/id/${ id }`;

		axios
			.get(query_url)
			.then((response) => {
				// Check returned data is object
				if (response) {
					resolve(response.data);
				} else {
					reject("could not get location");
				}
			})
			.catch((error) => {
				reject("could not get location");
			});
	});
}

/**
 * -setLocationsQuery-
 * @param {object} locations
 * Updates the URL for when location has been set by user interaction
 **/
export function setLocationsQuery(locations, pathname) {
	const valid_locations = _.filter(
		locations,
		(location) => location.lat && location.lng
	);
	const query =
		valid_locations.length > 0 ? JSON.stringify(locations) : undefined;
	const current = history.getCurrentLocation().pathname;
	const newPath = pathname ? pathname : current;
	const currentQuery = history.getCurrentLocation().query;

	history.push({
		pathname: newPath,
		query: { ...currentQuery, locations: query },
	});
}

/**
 * -promiseTimeout-
 * @param {int} ms
 * @param {function} promise
 * Create a promise race so promises can timeout
 **/
export function promiseTimeout(ms, promise) {
	// Create a promise that rejects in <ms> milliseconds
	let timeout = new Promise((resolve, reject) => {
		let id = setTimeout(() => {
			clearTimeout(id);
			reject("Timed out in " + ms + "ms.");
		}, ms);
	});

	// Returns a race between our timeout and the passed in promise
	return Promise.race([promise, timeout]);
}

/**
 * -getGeoLocation-
 * @return {promise}
 * Gets current lng/lat or returns error
 **/
export function getGeoLocation() {
	return new Promise((resolve, reject) => {
		const geolocation = navigator.geolocation;

		if (!geolocation) {
			reject("Geolocation not supported");
		}

		geolocation.getCurrentPosition(
			(position) => {
				resolve(position);
			},
			(error) => {
				reject("Could not get geolocation");
			}
		);
	});
}

/**
 * -getCurrentPage-
 * @return {string} current page
 * Returns the current page
 **/
export function getCurrentPage() {
	const pathname = history.getCurrentLocation().pathname;

	let pagename;
	if (pathname.indexOf("leisure-rides") !== -1) {
		pagename = "leisure-rides";
	} else if (pathname.indexOf("route-planning") !== -1) {
		pagename = "route-planning";
	} else if (pathname.indexOf("explore-map") !== -1) {
		pagename = "explore-map";
	}

	return pagename;
}

export function wrapURLs(text, new_window) {
	const url_pattern =
		/(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/gi;
	const target = new_window === true || new_window == null ? "_blank" : "";

	return text.replace(url_pattern, function(url) {
		const mail = url.includes("@");

		const protocol_pattern = /^(?:(?:https?|ftp):\/\/)/i;
		const href = protocol_pattern.test(url) ? url : "http://" + url;

		const newUrl =
			'<a href="' +
			href +
			'" target="' +
			target +
			'">' +
			url +
			`${ new_window ? (
				'<span className="new-window-prompt">(opens in a new window)</span>'
			) : (
				""
			)}` + '</a>';
		const mailTo = '<a href="mailto:' + url + '">' + url + "</a>";

		return !mail ? newUrl : mailTo;
	});
}

/**
 * 
 * @param {*} event 
 * Track link clicks using GA
 */
export function trackLinkClick(event) {
	const link = event.target;
	const href = link.getAttribute("href");
	const text = link.textContent;
	ReactGA.event({
	  category: _.startCase(getCurrentPage()),
	  action: text,
	  label: href,
	});
  }


/**
 * -checkIfLocations-
 * @return {boolean} 
 * Returns true if there are both from and to locations
 */
 export function hasToAndFromLocations (locations) {
  const hasFrom = locations.some((location) => location.type === 'from');
  const hasTo = locations.some((location) => location.type === 'to');
  return hasFrom && hasTo;
};



// WEBPACK FOOTER //
// ./src/helpers.js